import type { TLRecord } from '@digitalsamba/tldraw';
import { E2EEManager } from 'features/e2ee/E2EEManager';
import { e2eeEncrypt } from 'features/e2ee/utils/e2eeEncrypt';

// Turns one record into the string the server stores and sends back in `shapes`. Both the live
// update path and restoring go through here, so the two can never drift apart.
export const encodeWhiteboardRecord = async (record: TLRecord, encryptionKey?: CryptoKey) => {
  let data = record;

  // small hack for an E2EE scenario, swap base64 url with the original one before sending
  if (E2EEManager.e2eeEnabled && record.typeName === 'asset' && record.meta.src) {
    const copiedRecord = JSON.parse(JSON.stringify(record));
    copiedRecord.props.src = record.meta.src;
    // @TODO do we need to completely remove meta? so far it's acceptable
    copiedRecord.meta = {};

    data = copiedRecord;
  }

  const serializedData = JSON.stringify(data);

  return encryptionKey ? e2eeEncrypt(serializedData, encryptionKey) : serializedData;
};
